import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';

export default function ScrollReveal({
    children,
    width = "100%",
    delay = 0,
    direction = "up",
    className = ""
}) {
    const prefersReducedMotion = useReducedMotion();

    const getVariants = () => {
        const distance = 28;

        if (prefersReducedMotion) {
            return {
                hidden: { opacity: 0 },
                visible: { opacity: 1 }
            };
        }

        switch (direction) {
            case "up":
                return {
                    hidden: { opacity: 0, y: distance },
                    visible: { opacity: 1, y: 0 }
                };
            case "down":
                return {
                    hidden: { opacity: 0, y: -distance },
                    visible: { opacity: 1, y: 0 }
                };
            case "left":
                return {
                    hidden: { opacity: 0, x: distance },
                    visible: { opacity: 1, x: 0 }
                };
            case "right":
                return {
                    hidden: { opacity: 0, x: -distance },
                    visible: { opacity: 1, x: 0 }
                };
            case "scale":
                return {
                    hidden: { opacity: 0, scale: 0.96 },
                    visible: { opacity: 1, scale: 1 }
                };
            default:
                return {
                    hidden: { opacity: 0, y: distance },
                    visible: { opacity: 1, y: 0 }
                };
        }
    };

    return (
        // No overflow clipping here: children need to be able to lift and glow on hover.
        <motion.div
            style={{ width }}
            className={className}
            variants={getVariants()}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
        >
            {children}
        </motion.div>
    );
}
